import { Configuration, LogLevel, PopupRequest } from '@azure/msal-browser';

// src/authConfig.js
export const msalConfig: Configuration = {
  auth: {
    clientId: "bc93f654-95b7-4d32-ae78-36f88bcf770d", // application id
    authority: "https://login.microsoftonline.com/720b637a-655a-40cf-816a-f22f40755c2c", //object id
    redirectUri: "/",
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: "localStorage",
    temporaryCacheLocation: "sessionStorage",
  },
    system: {
    loggerOptions: {
        loggerCallback: (level, message, containsPii) => {
            if (containsPii) {
                return;
            }
            switch (level) {
                case LogLevel.Error:
                    console.error(message);
                    return;
                case LogLevel.Info:
                    console.info(message);
                    return;
                case LogLevel.Verbose:
                    console.debug(message);
                    return;
                case LogLevel.Warning:
                    console.warn(message);
                    return;
                default:
                    return;
            }
        },
    },
  },
};

export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
};